import { Button, Tooltip } from '@mui/material'
import CallEndIcon from '@mui/icons-material/CallEnd'
import { t } from '@lingui/macro'
import { Link } from 'react-router-dom'

export function QuitMeetingButton() {
  return (
    <Tooltip title={t`Quit meeting`}>
      <Button component={Link} to="/expertise-meetings" color="error" size="small" variant="contained" sx={{ borderRadius: '15px' }}>
        <CallEndIcon />
      </Button>
    </Tooltip>
  )
}
